import { DehydrationState } from "processInstanceList/model/ProcessInstanceData";
import { ElementType, IElement } from "../processEditor/model/IProcessData";
import { HashMap } from "../shared/model/HashMap";

export interface IExecutionDetails {
    processGuid: string;
    processVersion: number;
    steps: IStepReferenceData[] | null;
    state: string;
    id: number;
    parentId: number;
    exception: string;
    startTimeUtc: string;
    endTimeUtc: string;
    duration: string;
    parentName: string;
    environment: string;
    agentGroup: string;
    stepDataUri?: string;
    agent: string;
    triggerName: string;
    userName: string;
    processParameters?: object;
    processReturnValues?: object;
    hasLoggedSteps?: boolean;
    dehydrationState?: DehydrationState
}

export enum IExecutionState {
    Started = 5,
    FinishedAsZombie = 8,
    TerminatedByUser = 9,
    Exception = 12,
    Finished = 13,
    DeliveryFailed = 14
}

export interface IStepData {
    steps?: HashMap<string>; // deprecated, remove once no more 5.2.0/5.2.1 processes
    stepData?: HashMap<StepLogData>;
    loops: HashMap<string[]>;
    elementLoops: HashMap<string[]>;
    maxLoopIndexes: HashMap<number>;
}

export interface StepLogData {
    state: string;
    chunkName: string;
}

export const FailedStates = [
    IExecutionState.FinishedAsZombie, IExecutionState.TerminatedByUser, IExecutionState.Exception, IExecutionState.DeliveryFailed
];

export interface IChunkedStepData {
    [stepKey: string]: IStep;
}

export interface IStep extends IStepViewModel {
    parameters: any;
    result: any;
    taskRetries: string;
}

export interface IProcessData {
    id: number;
    name: string;
    version?: number;
    majorVersion?: number;
    minorVersion?: number;
    isSubprocess?: boolean;
    bpmn: string;
    usedTasks: HashMap<ITaskDetails>;
    elementParameters: IElement[];
}

export interface ITaskDetails {
    displayName: string;
    packageName: string;
}

export interface IStepViewModel {
    id: number;
    name: string;
    duration: string;
    startTimeUtc: string;
    endTimeUtc: string;
    stepId: string;
    processStepId?: number;
    stepExecutionId?: string;
    subprocessExecutionId?: string;
    state: string;
    loopParameters: LoopParameter[];
    processVariables?: string;
}

export interface IStepReferenceData {
    id: number;
    stepId: string;
    state: string;
    loopParameters: LoopParameter[];
}

export interface ILoop {
    loopExecutions: ILoopExecution[];
}

export interface ILoopExecution {
    count?: number;
    hasError: boolean;
    elementType: ElementType;
    parentLoopScopeExecutions: { [stepId: string]: number };
    stepsPerElement: _.Dictionary<IStepReferenceData[]>;
}

export interface LoopParameter {
    key: string;
    value: number;
}
